package ui.screens.home

import androidx.compose.animation.ExperimentalSharedTransitionApi
import androidx.compose.foundation.ExperimentalFoundationApi
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.unit.dp
import data.repository.FirebaseInvitationRepo
import models.Wonder
import thewedding_cmp.composeapp.generated.resources.Res
import thewedding_cmp.composeapp.generated.resources.roller_1_white
import ui.VideoPlayer
import ui.screens.GreetingByPath

enum class SwipeState {
    Start, End
}

/**
 * large enough number to avoid overlap in smaller screens
 */
private val MIN_PAGER_WIDTH = 1000.dp

@OptIn(
    ExperimentalFoundationApi::class,
    ExperimentalSharedTransitionApi::class,
)
@Composable
fun HomeScreen(
    initialWonder: Wonder,
    openDetailScreen: (Wonder) -> Unit,
    openNotInvited: () -> Unit,
    modifier: Modifier = Modifier
        .graphicsLayer {
        alpha = 1f
    }
        .background(Color.Transparent),
    onChangeCurrentWonder: (Wonder) -> Unit,
) = BoxWithConstraints(modifier) {
    val repo = FirebaseInvitationRepo()
    val name = GreetingByPath()
    val nameInvited by repo.checkInvitationByName(name).collectAsState(initial = null)
    val isInvited = remember { mutableStateOf(false) }
    val opened = remember(name) { mutableStateOf(false) }

    LaunchedEffect(nameInvited) {
        nameInvited?.let {
            if (!opened.value) {
                opened.value = true
                println("Home, Nama undangan ${it.key}, exists ${it.exists}")
                if (!it.exists) {
                    isInvited.value = false
                    openNotInvited()
                } else {
                    isInvited.value = true
                }
            }
        }
    }
    println("Home, isInvited: ${isInvited.value}")
    if (isInvited.value) {
        VideoPlayer(
            videoUrl = "video/sample.mp4",
            onSwipeUp = {
                openDetailScreen(initialWonder)
            },
            isClosed = false
        )
    } else {
        VideoPlayer("video/sample.mp4", { }, true)
    }
}

val bgTexture
    get() = Res.drawable.roller_1_white